"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "portoferraio": {
    "78fd8a68": [{
      "hkey": "49b2ecb7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "carpani": [{
      "hkey": "49b2ecb7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "portoferraio"
    }],
    "1521ed3e": [{
      "hkey": "b83e826c",
      "slug": "portoferraio",
      "name": "Portoferraio",
      "primary": true,
      "skipSearch": false
    }],
    "isola-di-montecristo": [{
      "hkey": "b83e826c",
      "slug": "portoferraio",
      "name": "Portoferraio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2a23a39": [{
      "hkey": "8900179f",
      "slug": "la-biodola-scaglieri",
      "name": "La Biodola-Scaglieri",
      "primary": true,
      "skipSearch": false
    }],
    "la-biodola": [{
      "hkey": "8900179f",
      "slug": "la-biodola-scaglieri",
      "name": "La Biodola-Scaglieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8153b076": [{
      "hkey": "b83e826c",
      "slug": "portoferraio",
      "name": "Portoferraio",
      "primary": true,
      "skipSearch": false
    }],
    "ottone": [{
      "hkey": "b83e826c",
      "slug": "portoferraio",
      "name": "Portoferraio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "41f32261": [{
      "hkey": "b83e826c",
      "slug": "portoferraio",
      "name": "Portoferraio",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "b83e826c",
      "slug": "portoferraio",
      "name": "Portoferraio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "283e5a30": [{
      "hkey": "8c076a2b",
      "slug": "acquabona-schiopparello",
      "name": "Acquabona-Schiopparello",
      "primary": true,
      "skipSearch": false
    }],
    "schiopparello": [{
      "hkey": "8c076a2b",
      "slug": "acquabona-schiopparello",
      "name": "Acquabona-Schiopparello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6caf4436": [{
      "hkey": "0008166c",
      "slug": "viticcio-acquaviva",
      "name": "Viticcio-Acquaviva",
      "primary": true,
      "skipSearch": false
    }],
    "viticcio": [{
      "hkey": "0008166c",
      "slug": "viticcio-acquaviva",
      "name": "Viticcio-Acquaviva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;